import FormHeader from 'components/Form/FormHeader';
import Link from 'components/Link';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import Notification from 'components/Notification';
import useMessage from 'hooks/useMessage';
import {FC, useState} from 'react';
import {useBackend} from 'state/backend';
import {jt, t} from 'ttag';

import {PdfFilenameSettingsBackendData} from '../types';
import Section from './Section';

const ViewPdfFilenameSettingsPage: FC = () => {
    const {successMessage} = useMessage<'successMessage'>();
    const {
        data: {isUpgradeRequired},
    } = useBackend<PdfFilenameSettingsBackendData>();

    const [showNotification, setShowNotification] = useState(!!successMessage);

    const link = (
        <Link
            href="https://help.makeleaps.jp/ja/articles/8059992"
            isOpenInNewTab={true}
            key={0}
        >
            {t`See details`}
        </Link>
    );
    const subTitle = jt`Select and choose the order of the components for Document PDF filenames. ${link}`;

    const upgradeLink = (
        <Link
            href="https://www.makeleaps.jp/pricing/"
            isOpenInNewTab={true}
            key={0}
        >
            {t`here`}
        </Link>
    );
    const upgradeText = jt`You do not have access to this feature at this plan level. See details of our plans ${upgradeLink} and upgrade your account.`;
    return (
        <div>
            {showNotification && (
                <Notification
                    className="mb-4"
                    onClick={() => setShowNotification(false)}
                    type="success"
                >
                    {successMessage}
                </Notification>
            )}
            <NavigationTabs.DocumentSettings selection="pdfFilenameSettings" />
            <FormHeader
                link={{
                    disabled: isUpgradeRequired,
                    href: window.Urls.pdf_filename_settings_edit(),
                    icon: 'edit',
                    kind: 'secondary',
                    label: t`Edit`,
                }}
                subtitle={subTitle}
                title={t`PDF Filename`}
            />
            {isUpgradeRequired && (
                <Notification className="mt-4" icon="warning" type="alert">
                    {upgradeText}
                </Notification>
            )}
            <Section sectionName="pdfFilenameEmployee" />
            <Section sectionName="pdfFilenameClient" />
        </div>
    );
};

export default ViewPdfFilenameSettingsPage;
